{
  "common": {
    "myQuotes": "My Quotes",
    "allQuotes": "All Quotes",
    "transferQuotesToContact": "Select a contact to transfer the quotes assigned to",
    "newQuote": "New Quote",
    "quoteName": "Quote Name",
    "quoteId": "Quote ID",
    "searchEqOptions": "Search Equipment Options",
    "noEqOptionFound": "No Equipment Option found",
    "youWantToArchiveQuote": "Archive Quote?",
    "youWantToDeleteQuote": "Delete Quote?",
    "restoreQuoteToDraftTitle": "Restore Quote to Draft?",
    "archiveQuote": "Archive Quote",
    "archiveItemSubtitle": "The quote will become uneditable and can't be sent for approval. You can restore the quote through this page or the Archived tab in Quotes. Are you sure you want to continue?",
    "archiveItemsSubtitle": "The quotes will become uneditable and can't be sent for approval. You can restore the quotes through this page or the Archived tab in Quotes. Are you sure you want to continue?",
    "deleteQuote": "Delete Quote",
    "restoreToDraft": "Restore to Draft",
    "emailPdfToCustomer": "Email PDF to Customer",
    "quoteOwnerNotFound": "Quote owner not found",
    "filedIsRequired": "This field is required",
    "fileWithSpaces": "File names cannot contain spaces. Please rename your file and try again.",
    "saveQuote": "Save Quote",
    "returnToDraft": "Return to Draft",
    "sold": "Sold",
    "singleError": "Error",
    "multipleErrors": "Errors",
    "onOrderPendingDelivery": "On order, pending delivery",
    "crdLabel": "CRD",
    "proposedSellingPrice": "Proposed Price",
    "proposedMargin": "Proposed Margin",
    "minimumSellingPrice": "Minimum Price",
    "targetSellingPrice": "Target Price",
    "totalPxPrice": "Total PX Price",
    "manufacturer": "Manufacturer",
    "overAllowance": "Overallowance",
    "restoreQuote": "Restore Quote",
    "archiveQuotes": "Archive Quotes",
    "deleteQuotes": "Delete Quotes",
    "restoreQuotes": "Restore Quotes",
    "addSelectedToQuote": "Add Selected to Quote",
    "createQuote": "Create Quote",
    "quoteItems": "Items QID-{{quoteId}}",
    "quoteNameIsMandatory": "Quote Name is mandatory",
    "quoteNameInvalidField": "Quote Name must be at least 3 characters long",
    "createQuoteOnBehalf": "Create Quote on Behalf of Another User",
    "backToMyQuotes": "Back To My Quotes",
    "selectedQuoteItems": "({{ nrOfItems }}) Quotes Selected",
    "archiveQuoteItems": "Archive ({{ nrOfItems }}) Quotes",
    "deleteQuoteItems": "Delete ({{ nrOfItems }}) Quotes",
    "restoreQuoteItems": "Restore ({{ nrOfItems }}) Quotes to Draft",
    "restoringQuoteToDraft": "Restoring the quote will return it to draft status and make it editable again. If any machines or attachments became unavailable or had price changes since the quote got archived, these will need to be fixed before the quote can be sent for approval. Are you sure you want to continue?",
    "youWantToArchiveQuotes": "Archive {{ nrOfItems }} Quotes?",
    "youWantToDeleteQuotes": "Delete {{ nrOfItems }} Quotes?",
    "youWantToRestoreQuotes": "Restore {{ nrOfItems }} Quotes to Draft?",
    "quotesWillBeDeleted": "The quotes will be permanently deleted and cannot be restored. Are you sure you want to continue?",
    "restoringQuotesToDraft": "Restoring the quotes will return them to draft status and make them editable again. If any machines or attachments became unavailable or had price changes since the quotes got archived, these will need to be fixed before the quotes can be sent for approval. Are you sure you want to continue?",
    "quoteWillBeDeleted": "The quote will be permanently deleted and cannot be restored. Are you sure you want to continue?",
    "showAllItemsInQuote": "Showing all items included within '{{quoteName}}' (QID-{{quoteId}})",
    "archiveQuoteSuccessMessage": "Successfully archived quote",
    "successfullyArchivedQuote": "Successfully archived {{ quoteName }}",
    "successfullyArchivedQuotes": "Successfully archived {{ quotesCount }} quotes",
    "successfullyDeletedQuote": "Successfully deleted {{ quoteName }}",
    "successfullyDeletedQuotes": "Successfully deleted {{ quotesCount }} quotes",
    "successfullyRestoredQuote": "Successfully restored {{ quoteName }}",
    "successfullyRestoredQuotes": "Successfully restored {{ quotesCount }} quotes",
    "quoteRestoredSuccess": "Successfully restored quote",
    "failedToDeleteSpecTemplate": "Failed to delete spec template",
    "failedToCopySpecTemplate": "Failed to copy spec template",
    "failedToCopySpecTemplatesToQuotation": "Failed to copy spec templates to quotation",
    "failedToCreateNewQuotation": "Failed to create new quotation",
    "failedToFetchQuotes": "Failed to fetch quotes",
    "createNewRule": "Create New Rule",
    "deleteRule": "Delete Rule",
    "ruleId": "Rule ID",
    "ruleName": "Rule Name",
    "fieldTooShort": "Minimum length should be {{minLength}} characters",
    "fieldTooLong": "Maximum length should be {{maxLength}} characters",
    "noLeadingSpaceAllowed": "The field cannot start with a space",
    "invalidEmails": "This field contains invalid email addresses",
    "notUniqueEmail": "This field contains email addresses used in other email fields at this level",
    "firstNameTooShort": "First Name must be at least 2 characters long",
    "firstNameTooLong": "First Name must be maximum 30 characters long",
    "lastNameTooShort": "Last Name must be at least 2 characters long",
    "lastNameTooLong": "Last Name must be maximum 30 characters long",
    "jobTitleTooShort": "Job Title must be at least 3 characters long",
    "jobTitleTooLong": "Job Title must be maximum 30 characters long",
    "enterValidEmailAddress": "Enter Valid Email Address",
    "specNameTooShort": "Spec Name must be at least 4 characters long",
    "enterBillingAddr1": "Address line 1",
    "enterBillingAddr2": "Address line 2",
    "enterBillingAddr3": "Address line 3",
    "enterState": "Locality name",
    "enterCity": "Enter city",
    "enterZipCode": "Enter post code",
    "enterCountry": "Select country",
    "requiredState": "Please fill in your locality name",
    "requiredCity": "Please fill in your city",
    "requiredZipCode": "Please fill in your post code",
    "requiredCountry": "Please fill in your country",
    "firstName": "First Name",
    "lastName": "Last Name",
    "emailAddress": "Email Address",
    "state": "Locality Name",
    "city": "City",
    "zipCode": "Post Code",
    "country": "Country",
    "search": "Search",
    "name": "Name",
    "status": "Status",
    "description": "Description",
    "save": "Save",
    "cancel": "Cancel",
    "noCancel": "No, Cancel",
    "logout": "Logout",
    "next": "Next",
    "delete": "Delete",
    "saving": "Saving...",
    "active": "Active",
    "edit": "Edit",
    "back": "Back",
    "create": "Create",
    "featureFlagsTitle": "Feature Flags",
    "featureFlagsSubtitle": "Enable or disable features for your tenant",
    "totalFlags": "Total Flags",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "featureFlagName": "Feature Flag Name",
    "featureFlagDescription": "Feature Flag Description",
    "featureFlagStatus": "Feature Flag Status",
    "feature": "Feature",
    "all": "All",
    "tenant": "Tenant",
    "changedBy": "Changed By",
    "lastChanged": "Last Changed",
    "featureFlagToastMessage": "You have successfully {{ action }} this feature flag.",
    "jobTitle": "Job Title",
    "customers": "Customers",
    "createdBy": "Created by",
    "lastUpdatedBy": "Last Updated by",
    "value": "Value",
    "cc": "CC",
    "bcc": "BCC",
    "introductionToFinance": "Introduction to Finance",
    "organizationTitle": "Organisation",
    "organizationDescription": "Switch between organisations you have access to. This will update your current session context.",
    "saveChanges": "Save Changes",
    "confirmToProceed": "Please confirm to proceed or save to retain your quote.",
    "sessionExpired": "Your session expired",
    "continueUsingApp": "Continue using the app",
    "404": "404",
    "nothingFound": "Nothing found, keep digging...",
    "pageNotFound": "We can't seem to find the page you're looking for. Try going back to the previous page or click below to go to the homepage.",
    "backToPreviousPage": "Back to Previous Page",
    "takeMeHome": "Take Me Home",
    "deleteContact": "Delete Contact",
    "selectDefaultContact": "Select a new default contact for",
    "contactInformation": "Contact Information",
    "defaultContact": "Default Contact",
    "originalContact": "Original Contact",
    "newCustomer": "New Customer",
    "customerName": "Customer Name",
    "phoneNumber": "Phone Number",
    "createNewSpec": "Create New Spec",
    "changeSpecName": "Change Spec Name",
    "addNewContact": "Add New Contact",
    "deliveryAddress": "Delivery Address",
    "billingAddress": "Billing Address",
    "billingAddressRemoved": "Billing address was successfully removed",
    "billingAddressSetAsDefault": "Billing address successfully set as default",
    "deliveryAddressSetAsDefault": "Delivery address successfully set as default",
    "deliveryAddressRemoved": "Delivery address was successfully removed",
    "addNewDeliveryAddress": "Add New Delivery Address",
    "defaultDeliveryAddress": "Default Delivery Address",
    "confirmSelection": "Confirm Selection",
    "addAddress": "Add Address",
    "cannotEditLeadContact": "Cannot edit contacts coming from the ERP",
    "cannotDeleteLeadContact": "Cannot delete contacts coming from the ERP",
    "cannotDeleteLastContact": "Customer needs to have at least one contact",
    "contactDetailsSetAsDefault": "Contact succesfully set as default.",
    "contactDetailsRemoved": "Contact details were successfully removed.",
    "deliveryNickname": "Delivery Nickname",
    "deliveryAddr1": "Delivery Address Line 1",
    "deliveryAddr2": "Delivery Address Line 2",
    "deliveryAddr3": "Delivery Address Line 3",
    "DraftAcceptedOnBehalfOfCustomer": "Draft Accepted by Customer (On Behalf)",
    "PendingLevel1Approval": "Pending Level 1 Approval",
    "PendingLevel2Approval": "Pending Level 2 Approval",
    "Level1ApprovedPendingLevel2Approval": "Level 1 Approved, Pending Level 2 Approval",
    "successMessageAcceptForCustomer": "The quote has been successfully accepted on behalf of the customer",
    "successMessagePreview": "The preview has been sent successfully",
    "draftSentSuccessfully": "The draft has been sent successfully",
    "Draft": "Draft",
    "DraftSentToCustomer": "Draft Sent To Customer",
    "DraftAcceptedByCustomer": "Draft Accepted By Customer",
    "DraftRejectedByCustomer": "Draft Rejected By Customer",
    "PendingLevel1AndLevel2Approval": "Pending Level 1 And Level 2 Approval",
    "Approved_Internal_L1": "Internally Approved By Level 1",
    "Rejected_Internal_L1": "Internally Rejected By Level 1",
    "Approved_Internal_L2": "Internally Approved By Level 2",
    "Rejected_Internal_L2": "Internally Rejected By Level 2",
    "Accepted": "Accepted",
    "Archived": "Archived",
    "Needs_revising": "Needs Revising",
    "Price_changed": "Cost Change",
    "draft": "Draft",
    "accepted": "Accepted",
    "archived": "Archived",
    "needRrevising": "Needs Revising",
    "costChange": "Cost Change",
    "items": "Items",
    "dealValue": "Deal Value",
    "quantity": "Qty",
    "lastEdited": "Last Edited",
    "dateCreated": "Date Created",
    "more": "More",
    "noItems": "No Items",
    "brand": "Brand",
    "model": "Model",
    "manufactureYear": "Manufacture Year",
    "category": "Category",
    "stockType": "Stock Type",
    "showFactoryfitOptions": "Show Factory Fit Options",
    "hideFactoryfitOptions": "Hide Factory Fit Options",
    "showDealerfitOptions": "Show Dealer Fit Options",
    "hideDealerfitOptions": "Hide Dealer Fit Options",
    "factoryFit": "Factory Fit",
    "dealerFit": "Dealer Fit",
    "dealerfitOptionsAmendments": "Dealer fit options are amendments made to the unit locally.",
    "signWritingDescription": "Signwriting on an excavator involves custom graphics and text on the machine's exterior for identification and branding purposes.",
    "priceAndCurrency": "{{price, currency(currency: GBP)}}",
    "selectBrand": "Select brand",
    "buckets": "Buckets",
    "hitches": "Hitches",
    "unavailableItem": "This Item is unavailable, please select another option.",
    "failedToIncreaseDecrease": "Failed to {{action}} item quantity",
    "failedToSelectDealerOption": "Failed to select dealer fit option",
    "failedToFetchDealerFits": "Failed to fetch dealer fits",
    "custom": "Custom",
    "optionName": "Option name",
    "enterCustomName": "Enter custom name",
    "newOption": "New option",
    "brands": "Brands",
    "inStockItemsLabel": "Only Display In-Stock",
    "type": "Type",
    "unitNumber": "Unit Number",
    "location": "Location",
    "daysInStock": "Days In Stock",
    "expectedArrivalDate": "Expected Receipt Date",
    "configuration": "Configuration",
    "noCompatibleAttachments": "There are no compatible attachments for this machine",
    "factoryFitDescription": "Factory fits are specification changes that can be made to the base unit before it leaves the Factory.",
    "noEquipmentOptionsAvailable": "Currently, there are no equipment options available for this attachment.",
    "searchEquipment": "Search Equipment",
    "tracks": "Tracks",
    "counterweight": "Counterweight",
    "armAndBoom": "Arm & Boom",
    "other": "Other",
    "customer": "Customer",
    "specificationName": "Specification Name",
    "specId": "Spec ID",
    "noneOfAbove": "None of the above",
    "specName": "Spec Name",
    "lastUpdated": "Last Updated",
    "searchCustomer": "Search customer",
    "deleteRecord": "Are you sure you want to delete this record? This action cannot be undone.",
    "archivedItemsInSpec": "Archived Items in Spec",
    "allItemsArchived": "All Items Have Been Archived",
    "itemsBrandWereArchived": "The below item(s) brand has been archived. If you click continue the saved spec will be added to quote without the archived item(s).",
    "itemsSpecWereArchived": "All items within this saved spec have been archived. You will not be able to add to quote.",
    "archivedItem": "Archived Item",
    "backToSpecs": "Okay, Back to Specs",
    "continueWithoutItem": "Okay, Continue Without Item(s)",
    "replaceItem": "Replace Item(s)",
    "requisiteItem": "Requisite Item(s)",
    "suggestItem": "Suggest Item(s)",
    "selectFollowingItems": "Please select from the following item(s) below to replace ",
    "selectItems": "Please select the item(s) that should be added with ",
    "selectFromFollowingItems": " usually requires one of the following item(s). Please select from the following item(s) below:",
    "confirm": "Confirm",
    "createName": "Create a name for your new specification to add this machine to",
    "changeName": "Change Name",
    "addItems": "Add Items",
    "changeSpecname": "Change the name for your spec",
    "moreSpecificQuoteName": "Give your quotation a more specific name to make it easier to search for later.",
    "deleteAttachment": "Delete Attachment",
    "searchPlaceholder": "Search...",
    "equipmentOptions": "Equipment Options",
    "customItems": "Custom Items",
    "services": "Services",
    "warranty": "Warranty",
    "serviceContract": "Service Contract",
    "serviceContractNone": "Service Contract - None",
    "transport": "Transport",
    "attachments": "Attachments",
    "thirdPartyName": "Third Party Name",
    "thirdPartyNamePlaceholder": "Enter Third Party Name",
    "monthsLowerCase": "months",
    "monthsUpperCase": "Months",
    "hrs": "Hrs",
    "noItemsSelected": "There are no items selected for this",
    "equipmentsNotCompatible": "The following {{equipments}} are NOT compatible with this specification and will not be added.",
    "equipmentsCompatible": "The following {{equipments}} are compatible with this specification. Click Confirm to add them.",
    "confirmCompatibleMachines": "Confirm Compatible Machines",
    "confirmCompatibleAttachments": "Confirm Compatible Attachments",
    "editContactInformation": "Edit Contact Information",
    "searchContactInformation": "Search contact information",
    "searchDeliveryAddress": "Search delivery address",
    "continueAfterEdit": "Are you sure you want to continue? Any changes will not be saved, and you will need to create a new quote after your edits.",
    "selectUser": "Select User",
    "searchUser": "Search user",
    "loading": "Loading...",
    "unitSpecificationAmendments": "Unit specification amendments at Factory or locally.",
    "overview": "Overview",
    "includeExtendedWarranty": "The option to include an extended warranty, in addition to the standard existing warranty on the unit.",
    "standard": "Standard",
    "extended": "Extended",
    "none": "None",
    "serviceUnavailable": "This service is unavailable, please select another option.",
    "deliveryToAsite": "Delivery to a site or for customers to collect locally.",
    "selectWarranty": "Select Warranty",
    "pleaseSelectWarranty": "Please select a Warranty!",
    "selectServiceContract": "Select service contract",
    "pleaseSelectServiceContract": "Please select a Service Contract!",
    "pleaseSelectTransport": "Please select a Transport Option!",
    "selectTransport": "Select Transport",
    "delivery": "Delivery",
    "customerCollect": "Customer Collect",
    "fitted": "Fitted",
    "agreementsForMaintenance": "An agreements for scheduled maintenance and repairs of the unit.",
    "arduous": "Arduous",
    "monthlyPaymentPlanOption": "Monthly Payment Plan Option cost:",
    "pricePerHour": "Price Per Hour:",
    "totalCost": "Total Cost:",
    "proposedPrice": "Proposed Price:",
    "xMonthTerm": "{{term}} Month Term ",
    "24MonthTerm": "24 Month Term -",
    "36MonthTerm": "36 Month Term -",
    "48MonthTerm": "48 Month Term -",
    "60MonthTerm": "60 Month Term -",
    "cardAction": "{{action}} {{rest}}",
    "deleteAttachmentFromMachine": "Delete Attachment From Machine",
    "itemsInMachineHaveErrors": "({{ nrOfItems }}) Items in this machine have errors/updates. Please revise them to continue with quote.",
    "itemsInMachineHaveCostChanges": "({{ nrOfItems }}) Items in this machine have cost changes.",
    "pricingForMachineChangedToLcc": "Pricing for this machine has changed to use life cycle costing.",
    "pricingForMachineChangedToNcc": "Pricing for this machine has changed and no longer uses life cycle costing.",
    "pricingForMachineChangedToLccAndCostChanges": "Pricing for this machine has changed to use life cycle costing, and ({{ nrOfItems }}) items have cost changes.",
    "pricingForMachineChangedToNccAndCostChanges": "Pricing for this machine has changed and no longer uses life cycle costing, and ({{ nrOfItems }}) items have cost changes.",
    "lccForMachineUpdated": "Life cycle costing pricing for this machine has {{ changeType }}.",
    "lccForMachineUpdatedAndChanges": "Life cycle costing pricing for this machine has {{ changeType }} and ({{ nrOfItems }}) items have cost changes.",
    "reviseEquipmentType": "Revise {{ equipmentType }}",
    "checkUpdates": "Check Updates",
    "itemBrandWasArchived": "This item's brand has been archived. Please remove this item to continue with quote.",
    "equipmentWasArchived": "This {{ equipmentType }} has been archived. Please remove this item to continue with quote.",
    "editQuoteDetails": "Edit Quote Details",
    "findReplacement": "Find Replacement",
    "remove": "Remove",
    "increased": "increased",
    "decreased": "decreased",
    "searchSpecification": "Search Specification",
    "internalNotes": "Internal Notes",
    "addAttachments": "Add Attachments",
    "addAttachment": "Add Attachment",
    "addAttachmentToMachineSpec": "Are you sure you want to add an attachment to this machine specification?",
    "total": "Total",
    "addToMachine": "Add to Machine",
    "pdi": "PDI",
    "transportFitted": "Transport - Fitted",
    "machines": "Machines",
    "tradeIns": "Trade Ins",
    "noNotesInternallyShared": "These are notes which are internally shared, to provide any additional information relevant to the customers quote.",
    "leaveWithoutSaving": "Leave Without Saving",
    "leaveWithoutSavingChanges": "Leave Without Saving Changes?",
    "failedToSaveConfiguration": "Failed to save configuration",
    "failedToDiscardConfiguration": "Failed to discard configuration",
    "configurationSavedSuccessfully": "Configuration saved successfully",
    "configurationDiscardedSuccessfully": "Configuration discarded successfully",
    "archivedItems": "Archived Items",
    "baseUnitsAreAvailable": "The following base unit items are now unavailable",
    "close": "Close",
    "baseUnit": "Base Unit",
    "baseUnitPriceChanged": "Price Unit Base Changed",
    "baseUnitListUpdated": "Base Units Updated",
    "factoryFitOptions": "Factory Fit Options",
    "dealerFitOptions": "Dealer Fit Options",
    "itemsNeedRevising": "({{ itemsNeedRevising }}) Items Need Revising",
    "mergeWith": "Merge With",
    "mergeDuplicatesTitle": "Merge Potential Duplicates",
    "deleteDeliveryAddress": "Delete Delivery Address",
    "deleteBillingAddress": "Delete Billing Address",
    "defaultBillingAddress": "Default Billing Address",
    "potentialDuplicates": "Potential Duplicate(s)",
    "addToNewQuote": "Add to New Quote",
    "addToSpec": "Add to Spec",
    "addToQuote": "Add to Quote",
    "revised": "Revised",
    "missingSpecs": "Missing Specs",
    "show": "Show",
    "choose": "Choose",
    "targetPrice": "Target Price:",
    "fieldMandatory": "{{ field }} is mandatory",
    "modelManufactureYear": "Model/Manufacture Year",
    "yom": "YOM",
    "yearOfManufacture": "Year of Manufacture",
    "percentageSymbol": "%",
    "modelName": "Model Name",
    "preview": "Preview",
    "notes": "Notes",
    "hours": "Hours",
    "backToSelection": "Back to Selection",
    "inStock": "In Stock",
    "unitDescription": "Unit Description",
    "dealerNetPrice": "Dealer NET Price ({{ currency }})",
    "transportType": "Transportation Type",
    "family": "Family",
    "itemName": "Item Name",
    "searchItems": "Search items",
    "equipmentType": "Equipment Type",
    "dlp": "DLP ({{ currency }})",
    "dnp": "DNP ({{ currency }})",
    "minTonnage": "Min Tonnage",
    "maxTonnage": "Max Tonnage",
    "rules": "Rules",
    "factor": "Factor",
    "discount1": "Discount1",
    "discount2": "Discount2",
    "inflation": "Inflation",
    "margin": "Margin",
    "minMargin": "Min Margin",
    "maxMargin": "Max Margin",
    "configure": "Configure",
    "selectFile": "Select File",
    "brandWarranties": "Brand Warranties",
    "cover": "Cover",
    "fileType": "File Type",
    "coverage": "Coverage",
    "createNewFamily": "Create New Family",
    "productCategory": "Product Category",
    "manageConfigurationRules": "Manage Configuration Rules",
    "selectModel": "Select model",
    "upload": "Upload",
    "changeFile": "Change file",
    "fileSizeExceed": "Cannot upload file. Total file size for all files exceeds {{ size }} MB.",
    "editBrand": "Edit Brand",
    "deleteRow": "Delete Row",
    "subType1": "Sub Type 1",
    "subType2": "Sub Type 2",
    "associatedMachines": "Associated Machines",
    "associatedAttachments": "Associated Attachments",
    "archiveItem": "Yes, Archive Item",
    "archiveItems": "Yes, Archive Items",
    "restoreItem": "Yes, Restore Item",
    "restoreItems": "Yes, Restore Items",
    "pricingIndexes": "Pricing Indexes",
    "thisWill": "This will:",
    "pricePerHourWithCurrency": "Price Per Hour ({{ currency }})",
    "wouldYouLikeToContinue": "Would you like to continue?",
    "markItemsAsUnavailable": "Mark the items as unavailable in all saved specs.",
    "ableToRestoreItemsLater": "You'll be able to restore the items later if needed. Are you sure you want to continue?",
    "changeStatusOfDraftQuotes": "Change the status of any draft quotes containing these items to \"Needs Revising\".",
    "itemsWillBeMadeActive": "Items will be made active and can be added to new quotes.",
    "itemsWillBecomeAvailable": "Items will become available in saved specs.",
    "quotesNotMarkedAsNeedsRevising": "Active quotes with these items will no longer be marked as \"Needs Revising\".",
    "apiErrorMessages": {
      "common.operationFailed": "Operation {{operation}} failed. {{details}}",
      "common.operationIsForbidden": "Operation is forbidden",
      "common.parameterIsMissing": "Parameter {{parameter}} is missing",
      "common.entityIdNotFound": "{{resourceType}} with ID {{id}} was not found",
      "common.entityIdNotFoundInParent": "{{resourceType}} with ID {{id}} was not found in {{parentResourceType}} with ID {{parentId}}",
      "common.entityNameNotFound": "{{resourceType}} with name {{name}} was not found",
      "common.validationFieldFailed": "Validation failed for field {{field}}. {{details}}",
      "common.actionIsNotAllowed": "{{action}} is not allowed",
      "common.accessActionDenied": "Access denied for action {{action}}",
      "common.alreadyExist": "{{resourceType}} already exists",
      "common.entityPropertyConflict": "{{resourceType}} with {{propertyName}} {{value}} already exists",
      "common.sendgridException": "Sendgrid exception occured",
      "common.notFoundInEnumeration": "{{value}} is not a valid name",
      "common.fieldCouldNotBeEmpty": "{{field}} should not be empty!",
      "common.negativeOrZeroQuantityNotAllowed": "Negative or zero quantity not allowed",
      "common.propertyValueOutOfRange": "{{propertyName}} should be between {{minValue}} and {{maxValue}}",
      "common.duplicatedEntity": "Duplicated {{entity}}.",
      "common.couldntReadFromBlobStorage": "Could not read from blob storage",
      "common.fileNotFound": "File was not found.",
      "approvals.secretDoesntMatch": "Secret doesn't match",
      "approvals.documentStatusTransitionImpossible": "Document cannot go from {{statusFrom}} to {{statusTo}} status",
      "approvals.documentWithGivenIdDoesntExist": "Document with the given id does not exist: {{documentId}}",
      "approvals.documentNotInSentToCustomer": "Document is not in sent to customer status",
      "approvals.missingApprovers": "At least one internal approval required",
      "approvals.missingApproverInLevelOneList": "User does not belong to level one approvers list",
      "approvals.missingApproverInLevelTwoList": "User does not belong to level two approvers list",
      "approvals.invalidDocumentStatus": "Invalid Document Status",
      "approvals.recipientsNotUnique": "Each email address should be unique between to, cc, and bcc",
      "approvals.emailTemplateTypeDoesntExist": "Email template type doesn't exist in EmailTemplateType enumeration",
      "approvals.elsaDefinitionNotFound": "Elsa definition: {{definitionName}} not found",
      "approvals.cannotDeleteActiveRule": "Cannot delete an active rule.",
      "quotations.contactIdNotFoundForCustomerId": "Contact id: {{contactId}} not found for Customer id: {{customerId}}",
      "quotations.deliveryAddressIdNotFoundForCustomerId": "Delivery address id: {{deliveryAddress}} not found for Customer id: {{customerId}}",
      "quotations.quotationsWereNotFound": "Quotations were not found",
      "quotations.quotationIsIncomplete": "Quotation with id: {{id}} is incomplete",
      "quotations.quotationsWithIdsNotFound": "Quotations with ids: {{quotationIds}} not found",
      "quotations.quotationWasNotAccepted": "Quotation with id: {{quotationId}} was not accepted",
      "quotations.quotationIsInNeedsRevising": "Quotation with id: {{quotationId}} is in Needs Revising status and cannot be updated!",
      "quotations.stockItemIsSoldUnit": "Stock item id: {{stockItemId}} is a sold unit",
      "quotations.noCatalogItemForStockItem": "Error no Catalog item for stock item with id {{stockItemId}}",
      "quotations.stockItemAlreadyInUse": "Stock item with id: {{stockItemId}} is already in use",
      "quotations.machineNotInQuotation": "Machine with id: {{machineItemId}} is not in quotation {{quotationId}}",
      "quotations.machineAttachmentNotInQuotation": "Machine attachment with id: {{machineAttachmentId}} is not in quotation {{quotationId}}",
      "quotations.dealerOptionIsNotInMachineAttachment": "Dealer option id {{dealerOptionId}} not found for  Machine attacment id {{machineAttachmentId}}",
      "quotations.pleaseRefreshQuotationBeforeSave": "Please refresh quotation before save!",
      "quotations.noQuotationIdsProvided": "No quotation ids provided",
      "quotations.quantityMustBeGreaterThanZero": "Quantity must be greater than 0",
      "quotations.noItemToUpdate": "No item to update",
      "quotations.quotationCannotBeDeletedApprovalStatus": "Quotation with id: {{quotationId}} cannot be deleted, because it is in an approval flow status",
      "quotations.noDealerOptionsInMachine": "No dealer options : {{dealerOptions}} in machine with id {{machineId}}",
      "quotations.noDealerOptionsInAttachment": "No dealer options : {{dealerOptions}} in attachment with id {{attachmentId}}",
      "quotations.noDealerOptions": "No dealer options : {{dealerOptions}}",
      "quotations.noFactoryOptionIdInMachine": "No factory option id: {{factoryOptionId}} in machine with id {{machineId}}",
      "quotations.noFactoryOptionIdInAttachment": "No factory option id: {{factoryOptionId}} in attachment with id {{attachmentId}}",
      "quotations.machineIdDoesntExistInQuotation": "Machine with id: {{machineId}} doesn't exist in quotation: {{quotationId}}",
      "quotations.machineWithIdWasNotFound": "Machine with id: {{machineId}} was not found",
      "quotations.quotationIdWasNotFound": "Quotation with id: {{quotationId}} was not found",
      "quotations.setUpMinimalCustomFactoryOption": "Set up minimal 1 item for custom factory option",
      "quotations.invalidWarrantyItemType": "Invalid warranty item type: {{warrantyItemType}}",
      "quotations.templateNeedsMachineType": "Template is incomplete. Needs a machine type",
      "quotations.templateNeedsAttachmentType": "Template is incomplete. Needs an attachment type",
      "quotations.templateIsNotMachineType": "Template with id {{templateId}} is not Machine type",
      "quotations.financeEmailIsMissingInUserSettings": "Finance Email addres is missing in user settings",
      "quotations.quotationMinimumEquipment": "Quotation with id: {{id}} should have at least 1 machine or attachment",
      "quotations.templateFromSpecCouldNotBeReceived": "Template from Spec could not be received",
      "quotations.specForCustomerNotFound": "Spec {{specId}} for Customer {{customerId}} not found",
      "quotations.problemDeletingSpecById": "Something went wrong while deleting spec by id: {{specId}}",
      "quotations.removeIncorrectWarranty": "Please remove incorrect warranty",
      "quotations.configurationRuleActionNotSelected": "Configuration rule action not selected",
      "quotations.machinePricePositive": "Sell price for machine with id {{machineId}} can't be 0 or less",
      "quotations.attachmentPricePositive": "Sell price for attachment with id {{attachmentId}} can't be 0 or less",
      "quotations.quoteSentForApprovalCannotBeEdited": "Quote sent for approval cannot be edited. If you wish to make changes, return the quote to draft.",
      "quotations.onlyCustomOptionsUpdatable": "Only custom options can be updated.",
      "quotations.concurencyError": "Concurency error",
      "quotations.dealerOptionIsArchived": "Dealer option {{dealerOption}} in machine with id {{machineId}} is archived",
      "quotations.tonnageOutOfRange": "Machine tonnage {{machineTonnage}} is out of range. Min tonnage: {{minTonnage}} max tonnage: {{maxTonnage}}.",
      "quotations.quotationNotInDraft": "Quotation is not in status draft",
      "quotations.stockItemUsedInQuotation": "Stock item {{stockItemId}} already used in quotation {{quotationId}}",
      "quotations.stockItemNotAttachmentType": "Stock item is not of type Attachment",
      "quotations.stockItemCopyNotAllowed": "Stock item copy is not allowed",
      "quotations.quotationStatusIncorrect": "Quotation Status is incorrect",
      "machines.minimumBrandAlias": "Brand needs to have at least 1 Alias defined",
      "machines.fileTypeIsWrong": "file type is wrong. Supported: .png, .jpg, .jpeg!",
      "machines.widthHeightPositive": "Width and height must be positive values",
      "machines.flatPdiForbidden": "DI for Brand level price rules cannot be flat amount",
      "machines.cannotDeleteBrandAlias": "Cannot delete Brand Alias since Brand must have at least 1 Alias.",
      "machines.fileMustBeXlsx": "File name: {{file.Name}} is in wrong format. Please upload reguired file with .xlsx extension.",
      "machines.fileCouldNotBeParsed": "File could not be parsed",
      "machines.duplicationReadingMachines": "Machines duplicates: {{machines}}",
      "machines.brandAliesNameMinLength": "Brand Alias Names must be at least 3 characters long.",
      "machines.duplicatedWarrantyOption": "Duplicated warranty option",
      "machines.noDealerOptionsInfile": "No dealer options in file.",
      "machines.duplicateDealerOption": "Double Dealer option in rows",
      "machines.brandWarrantyDiscountEnabled": "Brand warranty discount was enabled, but no value for discount provided.",
      "machines.itemsNotAvailableOrAlreadyLinked": "Item(s) not available or already linked.",
      "machines.machineAttachmentAlreadyContainsPriceRule": "Machine attachment already contains price rule.",
      "machines.machineAttachmentLacksPriceMatrix": "Machine attachment doesn't have Price Matrix Rule.",
      "machines.couldntLinkStocks": "Couldn't link Stocks to Equipment.",
      "machines.couldntRebuildRelations": "Couldn't rebuild Brand relatons.",
      "machines.fileMissingRequiredFields": "File is missing required fields.",
      "machines.fileContainsInvalidData": "The file contains invalid data or is corrupted. Check the file content and upload again or try uploading a different file.",
      "machines.maxMonthsAllowed": "Maximum of ten months allowed. Remove the extra columns and upload again",
      "machines.invalidBaseUnit": "Invalid data in required field base unit",
      "machines.optionNameDifferentInDb": "Option name is '{{Name}}' different from system '{{OldName}}'",
      "machines.optionNameDifferentSpelling": "The option name '{{FactoryOptionName}}' has duplicate variants in the file '{{DuplicatedOptionNames}}'",
      "machines.dealerOptionNameDifferentInDb": "Dealer option in system has other spelling: Family '{{Family}}', Type '{{Type}}', SubType1 '{{SubType1}}', SubType2 '{{SubType2}}', EquipmentType '{{EquipmentType}}', MachineCategory {{MachineCategory}}'",
      "machines.attacmentDealerOptionNameDifferentInDb": "Dealer option in system has other spelling: Family '{{Family}}', Type '{{Type}}', SubType1 '{{SubType1}}', SubType2 '{{SubType2}}', EquipmentType '{{EquipmentType}}', MappedModelName {{MappedModelName}}'",
      "users.failedToDeleteFile": "Failed to delete file: {{fileName}}",
      "users.failedToUploadFile": "Failed to upload file: {{fileName}}",
      "users.relationAlreadyExists": "Relation between role and permission already exists.",
      "users.failedToUpdateSignatureImage": "Failed to update signature image.",
      "shared.rules.invalidOperationException": "Operation {{operationName} is not {{typeName}}",
      "shared.rules.errorInProgramJson": "Error occured in Program JSON",
      "shared.rules.noSourceForInstruction": "No source for instruction",
      "shared.rules.noResultRuleInstruction": "No result rule instruction",
      "shared.rules.moreThanOneResultRuleInstruction": "More than one result rule instruction",
      "shared.rules.operationNotInitialized": "Operation is not initialized",
      "shared.rules.circularCalculation": "Circular calculation",
      "shared.failedToRetrieveSystemBotToken": "Failed to retrieve system bot token.",
      "shared.daprRequestFailed": "Dapr request failed",
      "shared.jsonParseError": "Error while parsing json",
      "shared.couldntFetchFile": "Couldn't fetch file",
      "shared.invalidFile": "File provided is not valid. Accepted only csv files with delimiter '{{delimiter}}' in file: {{fileName}}.",
      "shared.missingHeadersInFile": "Missing headers: {{headers}} in file: {{fileName}}",
      "shared.unsupportedCulture": "Unsupported culture: {{culture}}. Supported cultures: {{supported}}",
      "shared.emailSendingDisabled": "Email sending is disabled",
      "shared.noRecepientsSpecified": "No recipients specified for email sending",
      "shared.requestTokenFailed": "Cannot continue since request token has failed",
      "shared.quotationStatusCannotBeChanged": "Quotation status cannot be changed from {{statusFrom}} to {{statusTo}}",
      "genericError": "Something went wrong. Please try again."
    },
    "pwa": {
      "installApp": "Install PriceCMD",
      "installButton": "Install",
      "gotItButton": "Got it",
      "iosSubtitle": "Add to your home screen for quick access",
      "androidSubtitle": "Install this app for a better experience",
      "iosInstructions": "To install this app on your iPhone/iPad:",
      "iosStep1": "Tap the Share button at the bottom of Safari",
      "iosStep2": "Scroll down and tap \"Add to Home Screen\"",
      "iosStep3": "Tap \"Add\" in the top right corner"
    }
  }
}
